import React, { useState } from "react";

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import addDays from "date-fns/addDays";
//import subDays from "date-fns/subDays";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
//import getDay from "react-datepicker";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import CustomDatePicker from "../CustomDatePicker";

export default function Calendar({ onHandleSelection }) {
  registerLocale("es", es);

  const isWeekday = (date) => {
    const day = date.getDay(date);
    return day !== 0 && day !== 6;
  };

  const getInitialDate = () => {
    let initialDate = addDays(new Date().setHours(0, 0, 0), 2);

    while (!isWeekday(initialDate)) {
      initialDate = addDays(initialDate, 1);
    }

    return initialDate;
  };

  /*----------------------------------------------------------------
    onChange = Si la hora continua siendo 00:00, es porque cambio fecha
    onChange = Si la hora anterior no es 00:00, y la hora nueva es la misma que estaba, cambio fecha

  */

  const [startDate, setStartDate] = useState(getInitialDate());
  const [customShowTimeSelect, setCustomShowTimeSelect] = useState(false);

  const handleChange = (newDate) => {
    //console.log(newDate, "newDate");
    setStartDate(newDate);
    setCustomShowTimeSelect(true);
    onHandleSelection(newDate);
  };

  const filterPassedTime = () => {
    const currentDate = new Date();
    const selectedDate = addDays(new Date(), 2);

    return currentDate.getTime() < selectedDate.getTime();
  };

  let includedHours = [9, 10, 11, 12, 14, 15, 16, 17];

  let includeTimeList = [];

  for (const iterator of includedHours) {
    includeTimeList.push(setHours(setMinutes(new Date(), 0), iterator));
    includeTimeList.push(setHours(setMinutes(new Date(), 30), iterator));
  }

  return (
    <Form>
      <Col xs={12} className="p-0 text-center">
        <Form.Group>
          <CustomDatePicker
            locale="es"
            selected={startDate}
            onChange={handleChange}
            customShowTimeSelect={customShowTimeSelect}
            showTimeSelect
            readOnly
            timeIntervals={30}
            timeCaption="Hora"
            dateFormat="d, MMMM yyyy h:mm aa"
            filterDate={isWeekday}
            popperPlacement="bottom"
            minDate={addDays(new Date(), 2)}
            maxDate={addDays(new Date(), 365)}
            open={true}
            filterTime={filterPassedTime}
            //excludeTimes={excludeTimesList}
            includeTimes={includeTimeList}
            //highlightDates={highlightWithRanges}
            showDisabledMonthNavigation
            placeholderText=" Selecciona fecha y hora"
            inline
          />
        </Form.Group>
      </Col>
    </Form>
  );
}

/*material complementario no utilizado*/

/*  let excludedhours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 13, 18, 19, 20, 21, 22, 23];

  let excludeTimesList = [];

  for (const iterator of excludedhours) {
    excludeTimesList.push(setHours(setMinutes(new Date(), 0), iterator));
    excludeTimesList.push(setHours(setMinutes(new Date(), 30), iterator));
  } */

/* popperPlacementPositions = [
    'auto',
    'auto-left',
    'auto-right',
    'bottom',
    'bottom-end',
    'bottom-start',
    'left',
    'left-end',
    'left-start',
    'right',
    'right-end',
    'right-start',
    'top',
    'top-end',
    'top-start'
  ] */

//ver feriados nacionales para colorear
// eslint-disable-next-line no-unused-vars
/*const highlightWithRanges = [
    {
      "react-datepicker__day--highlighted-custom-1": [
        subDays(new Date(), 4),
        subDays(new Date(), 3),
        subDays(new Date(), 2),
        subDays(new Date(), 1),
      ],
    },
    {
      "react-datepicker__day--highlighted-custom-2": [
        new Date("2021-11-26"), // cuando > 9 hay que sumarle 1
        addDays(new Date(), 1),
        addDays(new Date(), 2),
      ],
    },
  ];*/
